import React from 'react';

// Suwak pojedynczej wartości w stylu platformy (jak suwak ceny w filtrach listingu):
// szara ścieżka, niebieskie wypełnienie do wartości, biały uchwyt z niebieskim obrysem.
// Natywny input (przezroczysty) obsługuje interakcję i dostępność.
const BudgetSlider = ({ value, min, max, step = 1000, onChange, ariaLabel }) => {
  const clamped = Math.min(max, Math.max(min, Number(value) || min));
  const pct = ((clamped - min) / (max - min)) * 100;
  return (
    <div className="relative h-5 flex items-center">
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={clamped}
        onChange={(e) => onChange(e.target.value)}
        aria-label={ariaLabel}
        className="absolute z-20 h-4 w-full opacity-0 cursor-pointer"
      />
      <div className="relative z-10 h-1.5 w-full">
        <div className="absolute inset-0 rounded-full bg-gray-200" />
        <div className="absolute top-0 bottom-0 left-0 rounded-full bg-blue-500 transition-[width] duration-75" style={{ width: `${pct}%` }} />
        <div
          className="absolute w-4 h-4 -top-1.5 rounded-full bg-white border-2 border-blue-500 shadow-sm transition-[left] duration-75"
          style={{ left: `${pct}%`, transform: 'translateX(-50%)' }}
        />
      </div>
    </div>
  );
};

export default BudgetSlider;
